import { InventorTrendOverTime } from "./inventor-trend";
export default InventorTrendOverTime;
